import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class BlockService {

    getEventRoute = '/api/block/';

    constructor(private dataService: DataService) {
    };

    getLookUp(refresh: boolean) {
        return this.dataService.getData('/api/block/lookup', refresh);
    }
    // getLookUpbyId(refresh: boolean, id:number) {
    //     return this.dataService.getData('/api/block/lookup/'+id, refresh);
    // }

    getLookUpbyId(refresh: boolean, id: number) {
        return this.dataService.getData('/api/lookup/block/' + id, refresh);
    }

    getMunicipalitiesByDistrictId(refresh: boolean, id: number, langType: any) {
        return this.dataService.getData('/api/lookup/municipality/' + id + '/' + langType, refresh)
    }

    getLookUpbyDistrictId(refresh: boolean, id: number, langType: any) {
        return this.dataService.getData('/api/lookup/block/' + id + '/' + langType, refresh);
    }

    getLookUpbyBlockId(refresh: boolean, id: number) {
        return this.dataService.getData('/api/lookup/sector/' + id, refresh);
    }

    getLookUpbySectorId(refresh: boolean, id: number) {
        return this.dataService.getData('/api/lookup/awc/' + id, refresh);
    }

    get(refresh: boolean) {
        return this.dataService.getData('/api/block', refresh);
    }

    getById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/block/' + id, refresh);
    }

    getBlockById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/block/blocklist/' + id, refresh);
    }

    getLookUpbyHealthBlock(refresh: boolean, id: number) {
        return this.dataService.getData('/api/lookup/healthblock/' + id, refresh);
    }

    getLookUpbyPhc(refresh: boolean, id: number) {
        return this.dataService.getData('/api/lookup/phc/' + id, refresh);
    }

    getLookUpbyHsc(refresh: boolean, id: number) {
        return this.dataService.getData('/api/lookup/hsc/' + id, refresh);
    }

    getLookUpbyVillage(refresh: boolean, id: number) {
        return this.dataService.getData('/api/lookup/healthvillage/' + id, refresh);
    }

    save(result: any) {
        return this.dataService.post('/api/block', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    delete(id: number) {
        return this.dataService.delete('/api/block/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    ZoneList(id:any)
    {
        return this.dataService.getData('/api/lookup/zone/'+id+'/'+1,true)
    }

    getCourseList()
    {
        return this.dataService.getData('/api/lookup/course',true)
    }

    getAcademicYear(id:any)
    {
        return this.dataService.getData('/api/lookup/academicyear/'+id,true)
    }

    getHostelList(id:any)
    {
        return this.dataService.getData('/api/school/schoollist/'+id+'/'+1,true)
    }

    saveCommittee(data:any)
    {
        return this.dataService.post('/api/committeemember',data)
    }

    getVillagePanchayat(id:any)
    {
        return this.dataService.getData('/api/lookup/villagepanchayat/'+id+'/'+1,true)
    }

   getSchoolList(data:any)
   {
    return this. dataService.getData('/api/SchoolMaster/'+data.areaType+'/'+
        data.districtId+'/'+data.blockId+'/'+data.villageId+'/'+data.municipalityId+'/'+data.zoneId+'/'+data.departmentId,true)
   }
  
   getEducationalDistrict(id:any)
   {
    return this.dataService.getData('/api/lookup/eduDistrictList/'+id+'/'+1,true);
   }

   getRoute(districtId:number,langType:number,refresh:boolean)
   {
    return this.dataService.getData('/api/routemaster/routelist/'+districtId+'/'+langType,true)
   }

   getHostelType()
   {
    return this.dataService.getData('/api/lookup/hosteltype',true)
   }

   schoolSave(data:any)
   {
    return this.dataService.post('/api/SchoolMaster',data);
   }

   getSchoolById(id:any)
   {
    return this.dataService.getData('/api/SchoolMaster/'+id,true)
   }
   search(hostelcode:any)
   {
    return this.dataService.getData('/api/SchoolMaster/hostelinfo/'+hostelcode,true)

   }

   getClassList(id:any)
   {
    return this.dataService.getData('/api/ClassInfoMaster/getAll/'+id,true);
   }

   saveClassDetails(data:any)
   {
    return this.dataService.post('/api/ClassInfoMaster',data);
   }

   getclassType()
   {
    return this.dataService.getData('/api/lookup/classType',true)
   }

   getClassInfoById(id:any)
   {
    return this.dataService.getData('/api/ClassInfoMaster/'+id,true);
   }
   getCookingCenter(areaType:any,DistrictId:any,MunicipalityId:any,ZoneId:any,departmentId:any)
   {
    return this. dataService.getData('/api/CookingCenterMaster/'+areaType +'/'+ DistrictId+'/'+MunicipalityId+'/'+ZoneId+'/'+departmentId,true)
   }
   saveCookingCenter(data:any)
   {
    return this.dataService.post('/api/CookingCenterMaster',data);
   }
   getCookingCenterById(id:any)
   {
    return this.dataService.getData('/api/CookingCenterMaster/'+id,true)
   }
   getCookSchoolMap(data:any)
   {
    return this. dataService.getData('/api/CookingCenterSchoolMapping',true)
   }
   getLookUpCookingCentreById( districtId: number, municipalityId:number,refresh: boolean) {
    return this.dataService.getData('/api/lookup/cookingcenter/'+districtId+'/'+municipalityId , refresh)
   }
   getCookingSchoolById(id:any)
   {
    return this.dataService.getData('/api/CookingCenterSchoolMapping/'+id,true)
   }
   saveCookingCenterSchoolMap(data:any)
   {
    return this.dataService.post('/api/CookingCenterSchoolMapping',data);
   }
   getRoutes(districtId:any,cookingCenterId:any)
   {
    return this.dataService.getData('/api/routemaster/'+districtId+'/'+cookingCenterId,true)
   }
   getRoutesById(id:any)
   {
    return this.dataService.getData('/api/routemaster/'+id,true)
   }
   saveRoutes(data:any)
   {
    return this.dataService.post('/api/routemaster',data);
   }

schoolActive(id: any) {
  const url = `/api/SchoolMaster/Remove?id=${id}`;
  return this.dataService.post(url, null);
}

}
